// @react
import React, { ReactElement } from 'react'
// @typings
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @libraries
// @components
// @module components
import QueryError from 'modules/common/components/Errors/QueryError'
import CommunicationForm from 'modules/onBoarding/components/Communication/Form'

const CommunicationContainer = (): ReactElement => {
  /****************************
   *  HOOKS
   *****************************/

  /****************************************
   *  GQL HOOKS
   ****************************************/

  const { loading: isLoading, error: isError, data: userData } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  /****************************************
   *  RENDER
   ****************************************/

  if (isError) return <QueryError />

  return <CommunicationForm data={userData} isLoading={isLoading} />
}

export default CommunicationContainer
